import React from "react";
import { TextField } from "@material-ui/core";
import NumberFormat from "react-number-format";

const NumberFormatCustom = props => {
  const { inputRef, value, onChange, ...other } = props;

  return (
    <NumberFormat
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      decimalScale={2}
      value={value}

      suffix="%"
      {...other}
    />
  );
};

const PercentInput = ({ label, fieldName, values, handleChange, classes, ...props }) => (

  <TextField
    type="text"
    label={label}
    name={fieldName}
    value={values[fieldName]}
    onChange={handleChange}
    InputLabelProps={{
      FormLabelClasses: {
        root: classes.labelRoot
      }
    }}
    InputProps={{
      classes: {
        input: classes.inputField
      },
      disableUnderline: true,
      inputComponent: NumberFormatCustom
    }}
    {...props}
  />
);
export default PercentInput;
